// extracted by mini-css-extract-plugin
export default {"ChecksCard":"checksCardWithGroup_ChecksCard__YKRxw","dividerContainer":"checksCardWithGroup_dividerContainer__lD7th","noSectionCheck":"checksCardWithGroup_noSectionCheck__2R0FK"};